import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    WithStyles,
    createStyles,
    Button,
    Grid,
    Typography,
    Theme,
} from '@material-ui/core';

//@ts-ignore
import axios, { CancelToken, isCancel } from 'axios';
import {
    MyPATFileUploadTab,
    MyPATTextField,
    MyPatUploadProgress,
    MyPatVideoPlayer,
    MyPATMathField,
    MyPATAudioUpload,
} from "../../../../common";

import { connect } from 'react-redux';
import { showVideoModal } from './../../../actions/showVideoProgressActions';
import { updatePercentage,showUploadedVideo,updateVideoDetail } from './../../../actions/videoUploadedActions';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import ReactPlayer from 'react-player';
import contentService from '../../../services/contentService';
import { showMsg } from '../../../../course/actions/loaderAlert';
import videoServices from '../../../services/videoServices';
import config from '../../../../../config/config';
import DeletePopUp from '../wrapperComponent/popUps';
import { getKeyFromStreamUrl } from '../../../../../utils';
import * as JSLZString from 'lz-string';
import {
    Delete as DeleteIcon
} from '@material-ui/icons';
import { CONTENT_STATES } from '../../../../../constants/comman';
import MyPATBaseSection, { SectionFocusedContext, SectionFocusedContextValue } from '../../../../common/MyPATBaseSection';

const styles = (theme: Theme) => createStyles({
    root: {
        flex: 'grow'
    },
    tabsAlign: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    textAlignRight: {
        textAlign: "right"
    },
    addButtonAlign: {
        display: 'flex',
        alignContent: 'center',
        flexDirection: 'row-reverse'
    },
    chooseFromLibraryButton: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'space-around'

    },
    mb1x: {
        marginBottom: theme.spacing.unit
    },
    inputFormLabel: {
        fontSize: 18,
        top: 0,
        left: 0,
        position: 'absolute',
        color: theme.palette.text.primary,
        "& > span": {
            color: theme.palette.error.light,
        }
    },
    questionParagraph: {
        maxWidth: 380,
        '& >p': {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            margin: '0',
        }
    },
    questionInfo: {
        border: `1px solid ${theme.palette.grey[300]}`,
        "& > div": {
            padding: `0 ${theme.spacing.unit}px`
        },
        "& > div:first-child": {
            paddingTop: theme.spacing.unit,
            paddingBottom: theme.spacing.unit,
            borderRight: `1px solid ${theme.palette.grey[300]}`
        }
    },
    optionContent: {
        "& .btn-delete": {
            visibility: "visible"
        },
        '& p>img': {
            maxWidth: '100%'
        }
    },
    questionActionBtn: {
        padding: theme.spacing.unit * 2,
        minWidth: "42px",
        minHeight: "42px",
        border: "1px solid #DFDFDF",
        color: theme.palette.text.secondary,
        borderRadius: 4,
        position: 'absolute',
        right: '20px',
        top: '10px',
    },
    buttonAlign: {
        display: 'flex',
        alignContent: 'center',
    },
    notesBlockTitle: {
        fontSize: 20,
        fontWeight: 400,
        paddingTop: 20,
    },
    addQuestionTitle: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'Nunito',
    },
    tabsNotes: {
        fontSize: 16,
        fontWeight: 400,
        padding: 0,
        marginBottom: '15px',
    },
    tabsContainer: {
        border: 'solid 1px #E1E1E1',
        margin: '20px 0 10px 0',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 20,
            lineHeight: "22px",
            color: "#333333",
        },
    },
    tabsContainer2: {
        border: 'solid 1px #E1E1E1',
        margin: '5px 0 10px 0',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 20,
            lineHeight: "22px",
            color: "#333333",
        },
    },
    searchNotesinput: {
        fontSize: 14,
        fontWeight: 400,
        padding: 0,
        fontStyle: "italic",
        '& input': {
            paddingLeft: "40px",
        },
    },
    OrDivider: {
        margin: "50px 0 25px 0",
        display: "block",
        position: "relative",
        textAlign: "center",
        height: "50px",
        zIndex: 0,
    },
    orText: {
        background: "#E0E6E7",
        height: "40px",
        width: "40px",
        borderRadius: "100%",
        fontStyle: "italic",
        fontSize: 14,
        color: "#989898",
        display: "inline-block",
        paddingTop: "8px",
        "position": "absolute",
        "top": "-20px",
        left: '48%',
    },
    dividerBar: {
        "position": "absolute",
        "left": 0,
        "top": "15px",
        width: "100%",
        "content": " ",
        height: "1px",
        background: "#E0E6E7",
        "z-index": "1",
    },
    textAlignCenter: {
        textAlign: "center",
    },
    addPageMore: {
        background: '#FFF !important',
        color: '#1D7DEA !important',
        width: '100',
        marginRight: 6,
        border: '1px solid #1D7DEA',
        boxSizing: 'border-box',
        borderRadius: 4,
        fontWeight: 600,
        fontSize: '0.875rem',
    },
    seachQuestionText: {
        fontSize: 16,
        fontWeight: 400,
        padding: 0,
    },
    imgSearch: {
        "position": "absolute",
        "left": "30px",
        "top": "54px",
        "z-index": "1",
    },
    selectedQues: {
        paddingRight: '20px',
    },
    dialogContent: {
        padding: 0,
        maxHeight: '100%',
        marginTop: 74
    },
    mandatory: {
        color: 'red',
    },
    cardHeading: {
        fontWeight: theme.typography.fontWeightRegular,
        paddingTop: "15px",
    },
    notesTitle: {
        border: 'solid 1px #E1E1E1',
        margin: '5px 0 10px 0',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 16,
            lineHeight: "22px",
            color: "#333333",
            fontFamily: 'Nunito',
            display: "block",
            paddingBottom: "20px"
        },
    },
    addVideoBrowse: {
        width: '850px',
        margin: '0 auto',
    },
    dragLibrarysection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: '16px',
    },
    uploadURLContainer: {
        position: 'relative',
        width: '522px',
        margin: '0 auto',
        '& button': {
            padding: '0',
            minWidth: 'auto',
            width: '38px',
            height: '28px',
        },
    },
    addLibraryTitle: {
        display: 'block',
        padding: '10px 0 15px 0',
        color: '#333333',
        fontSize: '16px',
    },
    uploadArrowbtn: {
        position: 'absolute',
        right: '5px',
        top: '5px',
    },
    borderLeft: {
        borderLeft: 'solid 0.75px #999999',
    },
    subHeadingInputContainer: {
        padding: "20px 0px",
        "& > div:last-child > div": {
            marginTop: "5px"
        }
    },
    btnBlueBorder: {
        backgroundColor: "transparent",
        padding: "0 16px",
        fontWeight: 600,
        height: 36,
        fontSize: "16px",
        minWidth: "64px",
        border: "solid 1px #1D7DEA",
        color: "#1D7DEA",
        "&:hover": {
            backgroundColor: "transparent",
        },
    }
});
const filterContent: any = {
    contentFilterData: [{
        filterValue: 'contentType',
        isSelected: true,
        filters: [{
            filterValue: 'studymaterial',
            isSelected: true,
            filters: [
                {
                    filterValue: 'videos',
                    isSelected: true,
                    filters: []
                }
            ]
        }
        ]
    },
    {
        filterValue: 'status',
        isSelected: true,
        filters: [{
            filterValue: CONTENT_STATES.PUBLISHED,
            isSelected: true,
            filters: []
        }],
    }
    ]
}

interface MathPixDataInterface {
    confidence: number,
    confidenceRate: number,
    text: string,
    html: string
}


//@ts-ignore
interface AudioTabProps extends WithStyles<typeof styles> {
    classes: any,
    showVideoModal: Function,
    handleVideoSelect: Function,
    tabState: any,
    isUploadModal: any,
    showVideo: any,
    handlePageState: Function,
    pageKey: any,
    updatePercentage:Function,
    uploadPercentage:any,
    notesData:any,
    showUploadedVideo:Function,
    handleChooseFromAudioLibrary:Function,
    handleAddContent:Function,
    handleDeleteVideo:Function,
    handleReplaceVideo:Function,
    showMsg: Function,
    updateVideoDetail:Function,
    videoDetails:any,
    handleNotesData:Function,
}
interface AudioTabState {
    uploadImage: string,
    videoUrlState: any,
    uploadFileObj:any,
    fileSizeBar:any,
    deletePopUpDialog: any,
    chooseLibraryKey:any,
    mathEditor:any,
    isValidUrl:any,
    deletePopUpDialogforPage:any,
    deleteKey: any,
    isExistingVideo: any,
    inputUrl:any
}

//@ts-ignore
const cancelFileUpload = React.createRef(null)

class AudioTab extends Component<AudioTabProps, AudioTabState>{
    upload: any = null
    textarea: any = null
    isOpenUploadDialog: boolean = false;
    inputForPaste: any = null
    wrapperRef: any = null

    constructor(props: AudioTabProps, state: AudioTabState) {
        super(props);
   
        this.state = {
            uploadImage: "/assets/img/mylibrary/upload-image.png",
            videoUrlState: "",
            uploadFileObj:"",
            fileSizeBar:"0 of 0",
            deletePopUpDialog: false,
            chooseLibraryKey:'',
            mathEditor: null,
            isValidUrl:false,
            deletePopUpDialogforPage:false,
            deleteKey: '',
            isExistingVideo:false,
            inputUrl:""
        }
    }

    handleVideoUploaded = () =>{
        const { pageKey, notesData } = this.props;
        let noteId = notesData.content_Id;
        if(this.state.isValidUrl && this.isYouTubeUrl(this.state.videoUrlState)){

            videoServices.getYouTubeVideoUrl('mp4',this.state.videoUrlState,noteId).then(async (urlData: any) => {
                
                if(urlData.statusCode === 200){

                    //this.props.handlePageState(pageKey, 'videoURL', "video")( urlData.responseObject.video.url);
                    const videoUrl = urlData.responseObject.video.url;
                    const key = videoUrl.split("/").pop();
                    videoServices.getHlsUrl(key).then((response) => {
                       this.props.handlePageState(pageKey, 'videoURL', "video")(response);
                    }).catch(() => {
                        this.props.showMsg('Invalid Video ID', 'error');
                    })

                }else{
                    this.props.showMsg('Error occurred while uploading video', 'error');
                }
            });

        }else{
            this.props.handlePageState(pageKey, 'videoURL', "video")(this.state.videoUrlState);
        }

        this.props.showVideoModal(false);
        this.props.showUploadedVideo(true);
        this.setState({ isValidUrl : false, videoUrlState:""});
    }

    cancelUpload = () =>{
      if (cancelFileUpload.current)
        cancelFileUpload.current("User has canceled the file upload.");

        this.props.showVideoModal(false);
        this.setState({ isValidUrl : false, videoUrlState:""});
    }
    
    convertVideoSize = (bytes: any, decimals:any = 2) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    handleVideoSelect = async (event: any) => {
        const { pageKey } = this.props;
        let file: any = null;
        //On upload 
        if (event.target.files) {
            file = event.target.files[0]
        }
        //On Drop 
        if (event.dataTransfer && event.dataTransfer.files) {
            file = event.dataTransfer.files[0]
        }
       
        let fileSize = file.size / 1024 / 1024 ;
        let fileName = file.name;
        let contentType = fileName.split('.').pop();
        if(contentType !== 'mp4'){
            this.props.showMsg('Video formate should be mp4', 'error');
            return false;
        }
        if(fileSize > 500){
            this.props.showMsg('File size has exceeded it max limit of 500MB', 'error');
            return false;
        }
        
            this.props.updateVideoDetail(file);
            let noteId = this.props.notesData.content_Id;
            videoServices.getVideoSignedUrl(contentType,noteId).then(async (urlData: any) => {
            
            if (urlData.statusCode === 200) {
                let options: any = {
                    headers: {
                        'Content-Type': file.type
                    },
                    onUploadProgress: (progressEvent: any) => {
                        const { loaded, total } = progressEvent;
                        let percent = Math.floor((loaded * 100) / total)
                        let totalSize =  this.convertVideoSize(total);
                        let loadedSize = this.convertVideoSize(loaded);
                        
                        let sizeBar = `${loadedSize} of ${totalSize}`;
                        this.props.showVideoModal(true);
                        this.props.updatePercentage(percent);
                        this.setState({uploadFileObj:file,fileSizeBar:sizeBar,isExistingVideo:false});
                       
                    },
                    //@ts-ignore
                    cancelToken: new CancelToken(
                        (oncancel: any) => (cancelFileUpload.current = oncancel)
                    )
                }

                const axiosRes = await axios.put(urlData.responseObject.aws.signedUrl, file, options)
                    .then(res => {
                        if (res.status === 200) {

                            videoServices.getHlsUrl(urlData.responseObject.aws.Key).then((response) => {
                                this.setState({ videoUrlState: response });
                            }).catch(() => {
                                this.props.showMsg('Invalid Video ID', 'error');
                            })
                        }
                    })
                    .catch(err => {

                        if (isCancel(err)) {
                           this.props.showVideoModal(false);
                        }
                        this.props.updatePercentage(0);
                    });
            }
        });

    }

    isYouTubeUrl = (urlStr: any) =>{

        if(urlStr.length && (urlStr.match(/(http:|https:)?(\/\/)?(www\.)?(youtube.com|youtu.be)\/(watch|embed)?(\?v=|\/)?(\S+)?/) || urlStr.startsWith('V-') || urlStr.startsWith('v-'))) return true;
          return false;
    }

    handleURLInputChange = (e: any) => {
        this.setState({inputUrl:e.target.value});
    }


    handleURLInputSubmit = () => {
        
        let UrlStr = this.state.inputUrl;
        if(this.isYouTubeUrl(UrlStr)){
            const isValidUrl = ReactPlayer.canPlay(UrlStr);
            if(isValidUrl) {
                this.setState({ isValidUrl, videoUrlState:UrlStr,isExistingVideo:false})
                this.props.showVideoModal(true);
            } else {
                try {
                    contentService.list({
                        searchText: UrlStr.toUpperCase(), 
                        ...filterContent
                    }, 1, 50)
                    .then((res: any) => {
                        if (res && res.length && res[0].videoUrl) {
                            videoServices.getHlsUrl(res[0].videoUrl).then((response) => {
                                this.setState({
                                    isValidUrl: true,
                                    videoUrlState: response,
                                    isExistingVideo:true
                                });
                                this.props.showVideoModal(true);
                            }).catch(() => {
                                this.props.showMsg('Invalid Video ID', 'error');
                            })
                        } else {
                            this.props.showMsg('Either content Id is not valid or it is a draft content.', 'error');
                        }
                    }).catch(err => {
                            this.props.showMsg('Either content Id is not valid or it is a draft content.', 'error');
                        });
                } catch (error) {
                    this.props.showMsg('Invalid Video ID', 'error');
                }
            }
        }else{
            this.props.showMsg('Invalid url or content id', 'error');
        }
    }

    handelDescriptionChange = (e: any, pageKey: string) => {
        const { notesData: { pageState = {}, title = '', subjects = [], tags = [] } = {} } = this.props;
        this.props.handlePageState(pageKey, 'videoDescription', "video")(e.target.value);
    }
    handleCloseDialog = () => {
        this.setState({
            deletePopUpDialog: false,
        })
    }

    handleDeletePageWithPopUp = (pageKey: any,videoUrl: any) => {
        this.setState({
            deletePopUpDialog: false
        }, () => {
            
            this.props.handleDeleteVideo(pageKey);
            if(!this.state.isExistingVideo){
                this.deleteVideoFromS3(videoUrl);
            }
        })
    }

    deleteVideoFromS3 = (videoUrl: any) =>{
        
        videoUrl = JSLZString.decompressFromEncodedURIComponent(videoUrl) || '';
        const videoKey = getKeyFromStreamUrl(videoUrl);
        videoServices.deleteVideoFromS3('videoKey',videoKey).then(async (resData: any) => {

        if (resData.statusCode === 200) {
                this.props.showMsg(resData.responseMessage, "success");
            }else{
                this.props.showMsg('Unable to delete Video', 'error');
            }
        });
    }

    getPageNumber = (key: any): any => {
        const extractNumber = key.replace(/^\D+/g, '');
        return extractNumber;
    }

    setMathInstance = (mathEditor: any) => {
        this.setState({ mathEditor })
    }

    chooseFromLibrary = (pagekey: string) =>{

        this.props.handleChooseFromAudioLibrary(pagekey);
        this.setState({isExistingVideo:true });
    }
    
    addVideoPage = (pageKey: any): any => {
        const { classes, isUploadModal, showVideo,uploadPercentage,notesData:{pageState} } = this.props;
      
        return (
            <SectionFocusedContext.Consumer>
                {({ setSectionFocus }: SectionFocusedContextValue) => (
                    <MyPATBaseSection sectionId={`createNotes-${pageKey}`} applyFocusedBorder={false} onFocusChange={setSectionFocus}>
                        <div className={classes.tabsContainer}>
                            <div className={classes.tabsAlign}>
                                <b className={classes.addQuestionTitle}>Add Audio</b>
                            </div>
                                {isUploadModal &&
                                    <MyPatUploadProgress uploadPercentage={uploadPercentage} videoUrl={this.state.videoUrlState}  handleVideoUploaded={this.handleVideoUploaded} cancelUpload={() => this.cancelUpload} uploadFileObj={this.props.videoDetails} fileSizeBar={this.state.fileSizeBar} isValidUrl={this.state.isValidUrl} />
                                }

                                {pageState[`${pageKey}`].video.videoURL !=="" &&
                                    <>
                                    
                                    <DeletePopUp
                                        openDialog={this.state.deletePopUpDialog}
                                        handleClose={this.handleCloseDialog}
                                        deleteFunction={() => this.handleDeletePageWithPopUp(pageKey,pageState[`${pageKey}`].video.videoURL)}
                                        deleteText="Are you sure you want to delete this video permanently"
                                        deleteTitle="Delete Video"
                                />
                                        <Button
                                            variant="outlined"
                                            className={classes.questionActionBtn + "  btn-delete"}
                                            onClick={() => this.setState({
                                                deletePopUpDialog: true,
                                                deleteKey: pageKey,
                                            })}
                                        >
                                            {/* <DeleteIcon /> */}
                                            <img src="/assets/svg/myLibrary/delete-outline.svg" />
                                        </Button>

                                        <MyPatVideoPlayer width="400px" height="200px" videoURL={(!_.isUndefined(pageState[`${pageKey}`]))?pageState[`${pageKey}`].video.videoURL:""} controls={true} />
                                        <Typography
                                                variant="h6" style={{ fontSize: 16, fontWeight: 'normal', }}
                                            >
                                               Audio Title<span style={{color: 'red'}}>*</span>
                                        </Typography>
                                        <MyPATMathField
                                        variant='textarea'
                                        editorProps={{
                                            externalToolbarId: 'box',
                                            name: `videoTitle`,
                                            handleChange: this.props.handlePageState(pageKey, 'videoTitle','video'),
                                            setInstance: this.setMathInstance,
                                            editorId: pageKey,
                                            value: pageState[pageKey]['video']['videoTitle'] || ""
                                        }}
                                    />
                                        <Typography
                                                variant="h6" style={{ fontSize: 16, fontWeight: 'normal', }}
                                            >
                                                Custom Description
                                        </Typography>
                                        <MyPATMathField
                                        variant='textarea'
                                        editorProps={{
                                            externalToolbarId: 'box',
                                            name: `videoDescription`,
                                            handleChange: this.props.handlePageState(pageKey, 'videoDescription','video'),
                                            setInstance: this.setMathInstance,
                                            editorId: pageKey,
                                            value: pageState[pageKey]['video']['videoDescription'] || ""
                                        }}
                                    />
                                    </>
                                }

                            {pageState[`${pageKey}`].video.videoURL === "" &&
                                <>
                                <b style={{display:'block', textAlign:'center',}}>Add URL/Content ID</b>
                                <span style={{display:'block', textAlign:'center', padding:'15px 0 32px 0', fontSize:'12px', color:'#666666',}}>You can simply paste the Audio URL from the web or you can add a Topic ID</span>
                                    <div className={classes.uploadURLContainer}>
                                    <MyPATTextField
                                                    inputId="videoUrl"
                                                    name="videoUrl"
                                                    fullWidthControl
                                                    placeholder="Type Your Link Id or Topic Id Here"
                                                    inputProps={{
                                                        required: true,
                                                        minLength: 3
                                                    }}
                                                    // onKeyUp={(e: any) => this.handleURLInputChange1(e, pageKey)}
                                                    onChange={(e: any)=>this.handleURLInputChange(e)}
                                                />
                                                <Button
                                                variant="contained"
                                                color="primary"
                                                className={classes.uploadArrowbtn}
                                                onClick={() => this.handleURLInputSubmit()}
                                            >
                                                <img src="/assets/svg/learn/urlVideoarrowbtn.svg" /></Button>
                                    </div>
                                    <Typography variant="caption" className={classes.OrDivider}>
                                        <span className={classes.dividerBar}><b className={classes.orText}> OR </b></span>
                                    </Typography>


                                    <Grid item xs={12} className={classes.dragLibrarysection}>
                                        <Grid item xs={6}>
                                        <MyPATAudioUpload handleVideoSelect={() => this.handleVideoSelect(event)} /> 
                                        </Grid>
                                        <Grid item xs={6} className={classes.borderLeft}>
                                        <div className={classes.textAlignCenter}>
                                            <span className={classes.addLibraryTitle}>Add from My Library</span>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        className={classes.mb1x}
                                                        onClick={() => this.chooseFromLibrary(pageKey)}
                                                    >
                                                        Choose from Library
                                                        </Button>
                                                </div>
                                        
                                        </Grid>
                                    </Grid>
                                    
                                </>
                            }
                        </div>
                    </MyPATBaseSection>
                )}
            </SectionFocusedContext.Consumer>
        )
    }


    render() {
        
        return (
            <>
                {this.addVideoPage(this.props.pageKey)}
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        tabState: _.get(state, 'wrapperTabsReducers.activeTab', 1),
        isUploadModal: _.get(state, 'showVideoModalReducers.openModal', false),
        showVideo: _.get(state, 'videoUploadedReducers.showVideo', false),
        uploadPercentage: _.get(state, 'videoUploadedReducers.uploadPercentage',0),
        videoDetails: _.get(state, 'videoUploadedReducers.videoDetails',{})
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    showVideoModal: showVideoModal,
    updatePercentage:updatePercentage,
    showUploadedVideo:showUploadedVideo,
    showMsg: showMsg,
    updateVideoDetail:updateVideoDetail,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AudioTab));